import dayjs from 'dayjs'

function getPlanFormattedDateFromDate(date: Date | string) {
  return dayjs(date).format('MM-YYYY')
}

export { getPlanFormattedDateFromDate }
